module.exports = __webpack_public_path__ + "media/iphone.3e8e087e.mp4";